export default __webpack_public_path__ + "static/media/evreux5.aae66c00.jpg";